import Vue from 'vue';
import decode from 'jwt-decode';
import moment from 'moment/moment';

const modulePrefix = 'auth/';

const SET_TOKEN = modulePrefix + 'set';
const REQUEST_START = modulePrefix + 'start';
const REQUEST_SUCCESS = modulePrefix + 'success';
const REQUEST_ERROR = modulePrefix + 'error';

export const LOGIN_SSO = modulePrefix + 'login';
export const LOGOUT = modulePrefix + 'logout';
export const UNAUTHORIZED = modulePrefix + 'unauthorized';

function userFromToken(token) {
    if (!token || !token.length) return null;
    const decoded = decode(token);
    const issuedAt = moment(decoded.issuedAt).toDate().getTime();
    return {
        token: token,
        id: decoded.accountId,
        iat: issuedAt,
        exp: issuedAt + (decoded.ttl * 1000),
        consumerKey: decoded.consumerKey,
    };
}

function validUser(user) {
    // Verify the user data has not expired
    return user &&
        (typeof(user.token) === 'string') &&
        (user.exp > new Date().getTime()) &&
        (user.exp > user.iat);
}

export default {
    state: {
        token: localStorage.getItem('token'),
        loading: false,
        error: false,
    },
    mutations: {
        [SET_TOKEN](state, user) {
            if (user) {
                state.token = user.token;
                localStorage.setItem('token', user.token);
            } else {
                state.token = null;
                localStorage.removeItem('token');
            }
        },
        [REQUEST_START](state) {
            state.loading = true;
        },
        [REQUEST_SUCCESS](state) {
            state.loading = false;
            state.error = false;
        },
        [REQUEST_ERROR](state) {
            state.loading = false;
            state.error = true;
        },
    },
    actions: {
        // Sign a user in, returns a promise that resolves into the user object
        [LOGIN_SSO]({commit, state}, sso_token) {
            commit(REQUEST_START);
            return Vue.axios.post('auth/api/accounts/sso', {refresh_token: sso_token})
                .then((response) => {
                    //Successful login
                    const token = response.data.token;
                    const user = userFromToken(token);
                    if (validUser(user)) {
                        commit(SET_TOKEN, user);
                        commit(REQUEST_SUCCESS);
                        return user;
                    } else {
                        // Somehow the object in the token is invalid
                        throw new Error('Response token is invalid user');
                    }
                })
                .catch((e) => {
                    console.error(e);
                    commit(REQUEST_ERROR);
                    throw e;
                });
        },
        // Sign the current user out, returns a promise that resolves when the logout has completed
        [LOGOUT]: ({commit, state}) => {
            commit(SET_TOKEN, null);
            return Promise.resolve();
        },
        // When encountering an unauthorized error, immediately clear the current user data
        [UNAUTHORIZED]: ({commit, state}) => {
            commit(SET_TOKEN, null);
        },
    },
    getters: {
        currentUser: (state, getters) => {
            const user = userFromToken(state.token);
            return validUser(user) ? user : null;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js